import type { Vendor } from '../services/vendorService';

/**
 * Visible anchor text for vendor website links.
 * Peptide Titans must use the vendor name so crawlers see a branded dofollow link.
 */
export function getVendorWebsiteLinkText(vendor: Pick<Vendor, 'name'>): string {
  if (vendor.name.trim().toLowerCase() === 'peptide titans') {
    return vendor.name.trim();
  }
  return 'Visit Website';
}
